/**
 * Cart drawer and add-to-cart feedback.
 *
 * Without this file: the cart icon links to the cart page and add-to-cart
 * forms post normally. With it, adding stays on the page, the button shows a
 * spinner then "Added", and the drawer slides in with the updated cart. The
 * drawer markup comes from the cart-drawer section via the Section Rendering
 * API, so prices and availability are always rendered by Shopify.
 */
(function () {
  'use strict';

  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer || typeof drawer.showModal !== 'function') return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var SECTION = 'cart-drawer';
  var onCartPage = /\/cart\/?$/.test(window.location.pathname);

  function content() {
    return drawer.querySelector('[data-cart-drawer-content]');
  }

  function open() {
    if (drawer.open) return;
    drawer.showModal();
    document.documentElement.style.overflow = 'hidden';
    var close = drawer.querySelector('[data-cart-drawer-close]');
    if (close) close.focus();
  }

  function close() {
    if (drawer.open) drawer.close();
  }

  drawer.addEventListener('close', function () {
    document.documentElement.style.overflow = '';
  });

  // A click on the dialog element itself is a click on the backdrop.
  drawer.addEventListener('click', function (event) {
    if (event.target === drawer) close();
  });

  function updateHeaderCount(count) {
    document.querySelectorAll('.header__cart').forEach(function (link) {
      var hidden = link.querySelector('.visually-hidden');
      if (hidden) hidden.textContent = hidden.textContent.replace(/\(\d+\)/, '(' + count + ')');
      var bubble = link.querySelector('.header__cart-count');
      if (count > 0) {
        if (!bubble) {
          bubble = document.createElement('span');
          bubble.className = 'header__cart-count';
          bubble.setAttribute('aria-hidden', 'true');
          link.appendChild(bubble);
        }
        bubble.textContent = count;
      } else if (bubble) {
        bubble.remove();
      }
    });
  }

  function render(html) {
    if (!html) return;
    var next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-drawer-content]');
    var current = content();
    if (!next || !current) return;
    current.innerHTML = next.innerHTML;
    var count = parseInt(next.getAttribute('data-cart-count'), 10) || 0;
    current.setAttribute('data-cart-count', count);
    updateHeaderCount(count);
  }

  function showDrawerMessage(message) {
    var status = drawer.querySelector('[data-cart-drawer-status]');
    if (status) status.textContent = message || '';
  }

  function refresh() {
    return fetch(root + '?sections=' + SECTION, { credentials: 'same-origin' })
      .then(function (response) { return response.json(); })
      .then(function (sections) { render(sections[SECTION]); })
      .catch(function () {});
  }

  function errorFor(form) {
    var el = form.querySelector('[data-form-error]');
    if (!el) {
      el = document.createElement('p');
      el.className = 'product-form__error';
      el.setAttribute('role', 'alert');
      el.setAttribute('data-form-error', '');
      form.appendChild(el);
    }
    return el;
  }

  function setBusy(buttons, busy) {
    buttons.forEach(function (button) {
      if (busy) {
        button.setAttribute('aria-busy', 'true');
      } else {
        button.removeAttribute('aria-busy');
      }
    });
  }

  function flashAdded(buttons) {
    buttons.forEach(function (button) {
      if (button.dataset.addedTimer) return;
      var label = button.innerHTML;
      button.classList.add('is-added');
      button.textContent = 'Added ✓';
      button.dataset.addedTimer = window.setTimeout(function () {
        button.innerHTML = label;
        button.classList.remove('is-added');
        delete button.dataset.addedTimer;
      }, 1600);
    });
  }

  function addToCart(form, submitter) {
    var buttons = [];
    if (submitter) buttons.push(submitter);
    document.querySelectorAll('[data-add-mirror]').forEach(function (b) {
      if (buttons.indexOf(b) === -1) buttons.push(b);
    });

    var error = errorFor(form);
    error.textContent = '';
    setBusy(buttons, true);

    var body = new FormData(form);
    body.append('sections', SECTION);
    body.append('sections_url', window.location.pathname);

    var received = false;

    fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: body
    })
      .then(function (response) {
        received = true;
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        setBusy(buttons, false);
        if (!result.ok || result.data.status) {
          error.textContent = result.data.description || result.data.message || 'This set could not be added. Please try again.';
          return;
        }
        if (result.data.sections) {
          render(result.data.sections[SECTION]);
        } else {
          refresh();
        }
        showDrawerMessage('');
        flashAdded(buttons);
        open();
      })
      .catch(function () {
        setBusy(buttons, false);
        // The request never reached Shopify: fall back to the normal form post.
        // Once a response arrived the item may already be in the cart, so
        // refresh instead of risking a second add.
        if (received) {
          refresh().then(open);
        } else {
          form.submit();
        }
      });
  }

  function changeLine(line, quantity, item) {
    if (item) item.setAttribute('aria-busy', 'true');
    showDrawerMessage('');

    fetch(root + 'cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        line: line,
        quantity: quantity,
        sections: [SECTION],
        sections_url: window.location.pathname
      })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok || result.data.status) {
          if (item) item.removeAttribute('aria-busy');
          showDrawerMessage(result.data.description || result.data.message || 'The cart could not be updated.');
          return;
        }
        render(result.data.sections && result.data.sections[SECTION]);
        var closeButton = drawer.querySelector('[data-cart-drawer-close]');
        if (closeButton) closeButton.focus();
      })
      .catch(function () {
        if (item) item.removeAttribute('aria-busy');
        showDrawerMessage('The cart could not be updated. Please check your connection.');
      });
  }

  drawer.addEventListener('click', function (event) {
    if (event.target.closest('[data-cart-drawer-close]')) {
      close();
      return;
    }
    var change = event.target.closest('[data-cart-change]');
    if (change && !change.disabled) {
      var item = change.closest('[data-line]');
      if (!item) return;
      changeLine(parseInt(item.getAttribute('data-line'), 10), parseInt(change.getAttribute('data-cart-change'), 10), item);
    }
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    event.preventDefault();
    addToCart(form, event.submitter || form.querySelector('[type="submit"]'));
  });

  // On the cart page itself, the cart icon keeps its normal behaviour.
  document.addEventListener('click', function (event) {
    var link = event.target.closest('a.header__cart');
    if (!link || onCartPage || event.metaKey || event.ctrlKey || event.shiftKey) return;
    event.preventDefault();
    open();
  });

  // Returning through the back button can restore a stale cart from cache.
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) refresh();
  });

  window.LovelyCartDrawer = { open: open, close: close, refresh: refresh };
})();
